
import { Component, Vue } from "vue-property-decorator";
import VideoPageTep from "@/template/video/VideoPage.vue";
@Component
export default class VideoPage extends VideoPageTep {}
